import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus } from 'lucide-react';

const PAYMENT_METHODS = ['PhonePe', 'Google Pay', 'Paytm', 'Net Banking', 'Cash', 'Other'];

const RechargeForm = ({ form, setForm, onSubmit, submitting, testIdPrefix = 'recharge' }) => {
  return (
    <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-lg space-y-3">
      <h3 className="text-sm font-semibold text-emerald-800 flex items-center gap-2">
        <Plus className="w-4 h-4" /> Add New Recharge
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <div>
          <Label className="text-xs">Amount *</Label>
          <Input type="number" step="0.01" placeholder="0.00" value={form.amount} onChange={(e) => setForm(p => ({ ...p, amount: e.target.value }))} data-testid={`${testIdPrefix}-amount-input`} />
        </div>
        <div>
          <Label className="text-xs">Commission</Label>
          <Input type="number" step="0.01" placeholder="0.00" value={form.commission} onChange={(e) => setForm(p => ({ ...p, commission: e.target.value }))} data-testid={`${testIdPrefix}-commission-input`} />
        </div>
        <div>
          <Label className="text-xs">Date</Label>
          <Input type="date" value={form.date} onChange={(e) => setForm(p => ({ ...p, date: e.target.value }))} data-testid={`${testIdPrefix}-date-input`} />
        </div>
        <div>
          <Label className="text-xs">Payment Method</Label>
          <Select value={form.paymentMethod} onValueChange={(val) => setForm(p => ({ ...p, paymentMethod: val }))}>
            <SelectTrigger data-testid={`${testIdPrefix}-payment-method`}><SelectValue /></SelectTrigger>
            <SelectContent>
              {PAYMENT_METHODS.map(m => <SelectItem key={m} value={m}>{m}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="md:col-span-2">
          <Label className="text-xs">Notes</Label>
          <Input placeholder="Optional notes" value={form.notes} onChange={(e) => setForm(p => ({ ...p, notes: e.target.value }))} data-testid={`${testIdPrefix}-notes-input`} />
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={onSubmit} disabled={submitting} className="gap-2 bg-emerald-600 hover:bg-emerald-700" data-testid={`add-${testIdPrefix}-btn`}>
          <Plus className="w-4 h-4" />
          {submitting ? 'Adding...' : 'Add Recharge'}
        </Button>
      </div>
    </div>
  );
};

export default RechargeForm;
